import { LoginForm } from '../components/login/LoginForm'

export function LoginFormPage() {
  return <LoginForm />
}
